const staticText = {
  heading: 'Configuration',
  authentication: {
    applicationName: 'Application name',
    privacyPolicyUrl: 'Privacy policy URL',
    buttonText: 'Save',
  },
  oauth: {
    clientId: 'Client ID',
    clientSecret: 'Client secret',
    clientSecretInfo: 'Please store your client secret in a safe place. For security purposes, we will not show it again.',
    generate: 'Generate',
    regenerate: 'Regenerate',
    redirectUris: {
      heading: 'Redirect URIs',
      add: 'Add new redirect URI',
      exampleUri: 'Enter redirect URI',
      emptyState: {
        text: 'You haven’t configured any redirect URIs yet. Add a redirect URI below to enable the Smartcar authorization flow in your application.',
        image: '/assets/graphics/SadCar.svg',
      },
      delete: 'Delete',
      save: 'Add',
      cancel: 'Done',
      limitMessage: 'You\'ve reached the limit of 16 redirect URIs. Please remove a URI in order to add a new one.',
      default: 'Default',
      setAsDefault: 'Set as default',
    },
  },
  management: {
    managementApiToken: 'Application management token',
    regenerateModalTitle: 'Regenerate application management token',
    managementTokenInfo: 'Please store your management token in a safe place. For security purposes, we will not show it again.',
  },
  delete: {
    buttonText: 'Delete application',
  },
  publish: {
    currentlyPublished: 'Published',
    unsavedChanges: 'Unsaved changes',
    resetButton: 'Reset',
    publishButton: 'Publish',
  },
};

export default staticText;
